export default "__VITE_ASSET__BDG8iXn0__"